import axios from 'axios';
import { v1 as uuid } from 'uuid';
import { COOKIES, LOCAL_STORAGE } from '../src/utils/enum';
import { getCookieValue, deleteCookie } from '../src/utils/utils';
import {getConfig} from '../config';
import LocalStorage from './LocalStorage';
import { ENDPOINTS_CONST } from '../src/utils/api-constants';


export function getMessage(response) {
  return response?.meta?.displayMessage || response?.message;
}

export const basicHeaders = {
  accept: 'application/json',
  'Content-Type': 'application/json',
  'x-pmmodule-name': 'paytmmoney',
  'x-pmngx-key': 'paytmmoney',
  [COOKIES.SSO_TOKEN]: getCookieValue(COOKIES.SSO_TOKEN),
  [COOKIES.USER_AGENT]: getCookieValue(COOKIES.USER_AGENT),
};

export const log = (logs) => {
  if (getCookieValue(COOKIES.SSO_TOKEN)) {
    const {method, endpoint} = ENDPOINTS_CONST.LOG_ERROR;
    return makeRequest(method, endpoint(), {
      app: 'trading_view_platform',
      url: window.location.href,
      logs,
    }, {
      auth2: 'VM1jiFAqAO48l3qZgSZH',
    });
  }
  return null;
};

const REQUEST_METHODS = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
};

let cachedAuthToken = null;

export async function getAuthToken() {
  if (cachedAuthToken) {
    return cachedAuthToken;
  }
  
  try {
    const response = await fetch('/api/auth-token', {
      credentials: 'include'
    });
    
    if (!response.ok) {
      throw new Error('Failed to get auth token');
    }
    
    const data = await response.json();
    cachedAuthToken = data.authToken;
    return cachedAuthToken;
  } catch (error) {
    throw error;
  }
}

function makeRequest(method, endpoint, body = {}, customHeaders = {}, isSFCall) {
  return new Promise((resolve, reject) => {
    const newHeaders = isSFCall ? customHeaders : {
      ...basicHeaders,
      [COOKIES.SSO_TOKEN]: getCookieValue(COOKIES.SSO_TOKEN),
      [COOKIES.USER_AGENT]: getCookieValue(COOKIES.USER_AGENT),
      [COOKIES.PASSCODE_VERIFIED]: getCookieValue(COOKIES.PASSCODE_VERIFIED),
      'x-request-id': uuid(),
      ...customHeaders,
    };
    const options = {
      url: endpoint,
      method,
      headers: newHeaders,
    };
    switch (method) {
      case REQUEST_METHODS.GET:
      case REQUEST_METHODS.DELETE:
        options.params = body;
        options.data = {};
        break;
  
      case REQUEST_METHODS.POST:
      case REQUEST_METHODS.PUT:
        options.data = body;
        break;
  
      default:
        options.params = body;
    }
    axios.request(options).then(res => {
      resolve(res.data);
    }).catch(error => {
      const filteredOptions = {
        url: endpoint,
        method: method,
      };
      if (error.response) {
        filteredOptions.status = error.response?.status;
        filteredOptions.data = error.response.data;
        filteredOptions['x-request-id'] = error?.config?.headers['x-request-id'];
      } else {
        filteredOptions.message = error?.message;
        filteredOptions.timeout = error?.config?.timeout;
        filteredOptions['x-request-id'] = error?.config?.headers['x-request-id'];
      }
      try {
        if (endpoint !== ENDPOINTS_CONST.LOG_ERROR.endpoint()) {
          log([{
            level: 'error',
            key: 'api-error',
            timestamp: new Date().toISOString(),
            version: window.pmVersion,
            data: JSON.stringify({
              request: filteredOptions,
              url: window.location.href,
            }),
          }]);
        }
      } catch (err) {}
      if (error.response && error.response.data) {
          const errorData = error.response.data.meta || error.response.data;
          const status = errorData.status || error.response.status;
          if (status === 401
            || status === 403 || getMessage(errorData) === 'x_user_agent not passed correctly') {
            deleteCookie(COOKIES.SSO_TOKEN);
            deleteCookie(COOKIES.USER_AGENT);
            deleteCookie(COOKIES.PASSCODE_VERIFIED);
            window.location.href = `${getConfig().AUTH}?pmlEnv=tradingView`;
          }
          if (status === 419) {
            deleteCookie(COOKIES.PASSCODE_VERIFIED);
            window.location.href = `${getConfig().PASSCODE_URL}?pmlEnv=tradingView`;
          }
        }
      reject(error?.response?.data);
    })
  });
}

export default makeRequest;
